import React from "react"
import styled from "styled-components"
const Targetsinfo = ({ targetWords, lang }) => {
  return (
    <Wraper>
      {targetWords.map((word, index) => (
        <div className="targetsInfoSection" key={index}>
          <img
            src={word.icon}
            alt="target icon"
            className="aboutPageLogo icon"
          />
          <h3 className="aboutPageTitle">{word[lang].title}</h3>

          <p className="noLine">{word[lang].desc}</p>
        </div>
      ))}
    </Wraper>
  )
}

export default Targetsinfo
const Wraper = styled.div`
  margin-top: 80px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;

  .targetsInfoSection {
    border: 1px solid black;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);

    .icon {
      margin-top: -65px;
    }
    p {
      margin-bottom: 1px;
      line-height: 2;
    }
    .noLine {
      padding: 25px;
    }
    @media (max-width: 800px) {
      font-size: 1rem !important;
    }
  }

  @media (max-width: 650px) {
    display: none;
  }
`
